export const SIDEBAR_DRAWER_CLASS_NAME = 'sidebar-drawer';
export const NAV_DRAWER_CLASS_NAME = 'nav-drawer';
